import { defineComponent as _defineComponent } from 'vue'
import {
  useEprintDerived,
  useEprintSession
} from '@/composables/format-edit/useEprintSession'


export default /*#__PURE__*/_defineComponent({
  __name: 'EprintLoadingOverlay',
  setup(__props) {

const session = useEprintSession()
const { isLoading } = useEprintDerived(session)

return { __sfc: true,session, isLoading }
}

})